import React, {Component} from 'react';
import classnames from 'classnames';
import autobind from 'autobind-decorator'

import { isDescendant } from "../../utils/DomHelper"
import WindowEventHelper from "../../lib/WindowEventHelper";


class TImageSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open_layer : false,
        };
    }

    componentDidMount() {
		WindowEventHelper.add("click", this.handleWindowClick)
    }

    componentWillUnmount() {
		WindowEventHelper.remove("click", this.handleWindowClick)
    }

    @autobind
    handleClose() {
        this.setState({
            open_layer: false
        })
    }

    @autobind
    handleWindowClick(e) {
        const { root } = this.refs
        let target = e.target

        if (!isDescendant(root, target)) {
            this.handleClose()
        }
    }

    @autobind
    toggleLayer(e) {
        this.setState( {
            open_layer : !this.state.open_layer
        });
    }

    @autobind
    handleSelectionItem(item, e) {
        this.props.selectItem(item.value);
        this.toggleLayer(e);
    }

    render() {
        const { defaultClassName, items, selectedValue } = this.props;
        const selected = items.find(item => item.value == selectedValue)

        return (
        <div ref="root" className={classnames(defaultClassName, {'opt_open' : this.state.open_layer})}>
            <button type="button" className="btn_opt" onClick={ (e) => this.toggleLayer(e) }>
                <span className={"bg_menubar " + selected.value}>
					{selected.label}
				</span>
                <span className="ico_blog ico_open" />
            </button>
            <div className="layer_opt" style={{ paddingTop: '5px'}}>
				{items.map((item, idx) =>
					<label key={idx} className={ classnames("lab_set", {"on": item.value == selectedValue })}>
						<input type="radio" name={item.name} className="inp_set" defaultValue={item.value} onClick={(e) => this.handleSelectionItem(item, e)}/>
						<span className={"bg_menubar " + item.value}>{item.label}</span>
					</label>
				)}
                <button type="button" className="btn_close" onClick={(e) => this.toggleLayer(e)} style={{top:'15px'}}>
                    <span className="ico_blog"/>
                </button>
            </div>
        </div>
        );
    }
}

export default TImageSelect;
